
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/form-validierung",
      function () {
        return require("private-next-pages/basic-elements/form-validierung.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basic-elements/form-validierung"])
      });
    }
  